var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-3",attrs:{"outlined":""}},[_c('v-card-text',[_c('applicant-list',{attrs:{"applicants":_vm.applicants},on:{"on-save":_vm.reload}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }